<template>
	<Dialog
v-model:visible="visivel" header="Logout" :breakpoints="{
		'960px': '75vw', '640px': '90vw', '360px': '100vw'
	}" :modal="true" :closable="false" :draggable="false">
		<!--
			`align-items: center` no lugar do alinhamento padrão: o ícone de aviso
			tem 2rem e o texto ~1rem, então sem isso os dois assentam pela linha de
			base e o triângulo fica pendurado abaixo da frase.
		-->
		<div class="confirmation-content">
			<i class="pi pi-exclamation-triangle" />
			<span>Deseja sair?</span>
		</div>
		<template #footer>
			<!--
				Sim em azul, Não em vermelho, ambos preenchidos e do mesmo tamanho.

				Antes os dois eram `p-button-text` — dois links azuis idênticos, sem
				peso visual nem alvo de toque decente no coletor. A cor agora carrega
				a diferença entre confirmar e desistir, e não só o rótulo.
			-->
			<div class="acoes">
				<Button label="Sim" icon="pi pi-check" class="flex-1 justify-content-center"
					@click="$emit('confirm-logout')" />
				<Button label="Não" icon="pi pi-times" class="flex-1 justify-content-center" severity="danger"
					@click="$emit('cancel-logout')" />
			</div>
		</template>
	</Dialog>
</template>

<script lang="ts" setup>
	/**
	 * Confirmação de saída do sistema.
	 *
	 * Quem controla a exibição é o pai, por `v-if` sobre este componente; a prop
	 * `display` diz apenas em que estado ele nasce.
	 */

	defineEmits(['cancel-logout', 'confirm-logout']);

	const props = defineProps<{ display: boolean }>();

	/**
	 * Cópia local da prop para o `v-model:visible` do Dialog.
	 *
	 * Antes o `v-model` apontava direto para `props.display`, o que faz o Dialog
	 * tentar escrever numa prop — mutação que o Vue recusa. Passava despercebido
	 * só porque `:closable="false"` impedia o Dialog de se fechar sozinho; bastava
	 * habilitar o fechamento para o aviso aparecer e o estado divergir do pai.
	 */
	const visivel = ref(props.display);

	watch(() => props.display, valor => {
		visivel.value = valor;
	});
</script>

<style scoped>
	.confirmation-content {
		display: flex;
		align-items: center;
		gap: 0.75rem;
		padding: 0.5rem 0;
	}

	.confirmation-content .pi {
		font-size: 2rem;
		/* O triângulo é aviso, não decoração: âmbar o diferencia do texto. */
		color: #c07a1e;
		flex: none;
	}

	/*
	 * O rodapé do Dialog alinha os filhos à direita por padrão, o que deixava os
	 * botões encostados num canto. Aqui eles dividem a largura inteira, que é o
	 * alvo de toque que o coletor pede.
	 */
	.acoes {
		display: flex;
		gap: 0.5rem;
		width: 100%;
	}

	/*
	 * O tema do PrimeVue dá margem à direita a todo botão dentro de
	 * `.p-dialog-footer`, o que soma ao `gap` e deixa o par de botões mais
	 * estreito que o rodapé. `:deep` alcança o elemento do Button, que é filho
	 * gerado por outro componente e por isso escapa do escopo deste estilo.
	 */
	.acoes :deep(.p-button) {
		margin: 0;
	}
</style>
